<template>
  <div class="">
    <div class="title-value" @click='eventStap'>
      <div class="">
        <img src="../../assets/images/back.png" @click="$router.back(-1)" alt="" style="width:25px;margin:10px 0 0 20px;cursor:pointer;">
      </div>
      <div class="chain-title-a">
        <el-input v-model="inputVal" placeholder="节点ID、地址" style="width:300px;border-radius:0 5px 5px 0;"></el-input>
        <el-button type="primary" @click="search" style="margin-left:10px;">搜索</el-button>
      </div>
      <div id="Qknode">
        <p><img src="../../assets/images/history_u1.png" />&ensp;节点<b>{{routerQuery}}</b></p>
      </div>
      <div id="showNode">
        <ul>
					<li><label for="">节点归属：</label><span>北京</span></li>
					<li><label for="">节点地址：</label><span>{{nodeThings.nodeAddress}}</span></li>
					<li><label for="">启动时间：</label><span>{{nodeThings.startTime}}</span></li>
					<li><label for="">节点状态：</label><span>{{nodeThings.nodeState}}</span></li>
			   </ul>
			   <ul>
					<li><label for="">统计截止时间：</label><span>{{time}}</span></li>
					<li><label for="">创建区块数：</label><span>{{nodeThings.blockCount}}</span></li>
          <li><label for="">验证交易数：</label><span>{{nodeThings.tranCount}}</span></li>
					<li><label for="">分区ID：</label><span>{{nodeThings.zoneID}}</span></li>
			   </ul>
      </div>
      <div id="content">
        <div id="four_flash">
          <div id="NodeDIv">
            <!-- <ul id="lll" class="mobile"> -->
              <transition-group name="list" tag="ul" id="lll" class="mobile">
                <!-- <li v-for="(item,index) in dataA"  @click="liStop(item.blockHash)" :key='item.blockHeight' class="list-item">{{item.blockHeight}}/{{index}}</li> -->
                <li v-for="(item,index) in dataA" @click="liStop(item.blockHash,item.zoneId)" :key='item.blockHeight' class="list-item"><p></p><div style="line-height:70px;" :class="item.topA">
                  <p style="height:20px;line-height:3;">{{item.blockHeight}}</p>
                  <p style="height:20px;">{{item.zoneId}}</p>
                </div></li>
              </transition-group>
              <!-- </ul> -->
          </div>
        </div>
        <div class="but_left"><img src="../../assets/images/prev.png" alt="左"/></div>
        <div class="but_right"><img src="../../assets/images/next.png" alt="右"/></div>
      </div>
      <div id="YzContent" @click="YzContent">
        <i>Block</i>
        <div id='YzContentP'>
          <p class="clearfix">
            <label for="">计算难度</label>
            <span>{{alertThings.difficulty}}</span>
          </p>
          <p class="clearfix">
              <label for="">ID</label>
              <span>{{alertThings.blockHash}}</span>
          </p>
          <p class="clearfix">
            <label for="">打包时间</label>
            <span>{{alertThings.packTime}}</span>
          </p>
          <p class="clearfix">
            <label for="">验证节点</label>
            <span>{{alertThings.blockProcess}}</span>
          </p>
        </div>
        <div class="jiaoyi_list"><p style="border-bottom:none;">交易列表</p></div>
        <ol class="jiaoyi_list_ol">
          <li @click="chainprocess(item)" v-for="item in alertThings.tranList">{{item}}</li>
          <!-- <li @click="chainprocess(item.height)" v-for="item in dataA">{{item.height}}</li> -->
        </ol>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  name:'chainthing',
  data(){
    return{
      inputVal:'',
      nodeThings:'',
      dataA:[

      ],
      nodeHash:'',
      dataB:[],
      time:'',
      alertThings:'',
      routerQuery:this.$route.query.nodes
    }
  },
  mounted(){
    this.getBlock();
    this.getNode();
    // this.liStop();
    var date = new Date();
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
    var D = date.getDate() + ' ';
    var h = date.getHours() + ':';
    var m = date.getMinutes() + ':';
    var s = date.getSeconds();
    this.time = Y+M+D+h+m+s
  },
  methods: {
    //跳转三级页
    chainprocess(e){
      this.$router.push({
        path:'/chainprocess',
        query:{'transaction':e}
      })
    },
    getNode(){
      let zoneid = this.routerQuery+','+this.$route.query.zoneid;
      let params = {
          nodeID:this.routerQuery,
          nodeHash:this.nodeHash,
      }
      params = this.$qs.stringify(params,{ indices: false });
      this.axios({
          method:'post',
          url:window.API_HOST+'/chain/findNodeInfo',
          data:params,
      }).then((res)=>{
        console.log(1111);
        console.log(res.data)
          this.nodeThings = res.data;
      })
    },
    YzContent(event){
      event.stopPropagation();
    },
    eventStap(){
      event.stopPropagation();
      $("#YzContent").css({"transform":"translateX(647px)","transition":"2s ease","display":"block !important"});
    },
    //搜索节点信息
    search(){
      var _this = this;
      window.clearInterval(_this.setInterval_ID)
      var re = /^[0-9]+.?[0-9]*$/; //判断字符串是否为数字 //判断正整数 /^[1-9]+[0-9]*]*$/
　　  var nubmer = this.inputVal;
  　　if (!re.test(nubmer)) {
  　　　　this.nodeHash = nubmer;
         this.routerQuery = '';
      }else{
        this.nodeHash = '';
        this.routerQuery = nubmer;
      }
      this.getBlock();
      this.getNode();
    },
    liStop(a,zoneid){
      // event.stopPropagation();
      if(zoneid == '1'){
        return;
      }
      window.event? window.event.cancelBubble = true : e.stopPropagation();
      $("#YzContent").css({"transform":"translateX(0)","transition":"2s ease","display":"block"});
      let params = {
          blockHash:a,
          nodeId:this.routerQuery,
      }
      // params = Object.assign(params,this.form);
      params = this.$qs.stringify(params,{ indices: false });
      this.axios({
          method:'post',
          url:window.API_HOST+'/chain/findBlockInfo',
          data:params,
      }).then((res)=>{
          console.log(res.data)
          this.alertThings = res.data;
      })
    },
    aaa(){
      console.log('3232323');
    },
    //获取block信息
    getBlock(){
      var block;
      var _this = this;
      let zoneid = this.routerQuery+','+this.$route.query.zoneid;
      let params = {
          type:'0',
          nodeId:zoneid,
          nodeHash:this.nodeHash,
          limit:'315'
      }
      params = this.$qs.stringify(params,{ indices: false });
      this.axios({
          method:'post',
          url:window.API_HOST+'/chain/findBlockHeight',
          data:params,
      }).then((res)=>{
        console.log(res.data)
        var data = res.data.blockList;
        for (let i = 0; i < data.length; i++) {
          if(data[i].blockHash == "null"){
            data.splice(i,1);
          }
        }
        this.dataA = data;
      	 if(data.length>0){
      		block = data[0].id;
      		//  点击左右切换
      			var _index5=0;
      			$(".but_left").hide();
      		    $(".but_right img").click(function(){
      		        _index5++;
      		        var len=$("ul.mobile li").length;
      		        if(_index5+5>len || Math.floor(len / 7) == _index5){
      		            // $(".but_right").hide();
      		        }else{
      		        	$(".but_right").show();
      		        };
      		        if(_index5>0 && _index5<len){
      		        	$(".but_left").show();
      		        }else{
      		        	$(".but_left").hide();
      		        };
      		        $("ul.mobile").stop().animate({left:-_index5*140*7},1000);
      		    	if(_index5 >= Math.floor(_this.dataA.length / 7)){
      		    		var blockId = $("#lll").find("li:last-child").attr("pid");
                  let params3 = {
                      type:'2',
                      nodeId:zoneid,
                      blockHeight:_this.dataA[_this.dataA.length-1].blockHeight,
                      limit:'7'
                  }
                  params3 = _this.$qs.stringify(params3,{ indices: false });
                  _this.axios({
                      method:'post',
                      url:window.API_HOST+'/chain/findBlockHeight',
                      data:params3,
                  }).then((res)=>{
                    var data = res.data.blockList;
          						if(data != null){
                        for(let i=0;i<data.length;i++){
                          _this.dataA.push({'blockHeight':data[i].blockHeight});
                        }
          						};
                    })
      		    	}
      		    });
      		    $(".but_left img").click(function(){
      		    	$(".but_right").show();
      		        if(_index5==1){
      		            $(".but_left").hide();
      		        }else{
      		        	$(".but_left").show();
      		        }
      		        _index5--;
      		        $("ul.mobile").stop().animate({left:-_index5*140*7},1000);
      		    });
      		    _this.setInterval_ID = setInterval(function () {
                if(_this.dataA.length == "0"){
                  $(".but_right").hide();
                  return;
                }
                let params2 = {
                    blockHeight:_this.dataA[0].blockHeight,
                    nodeId:_this.routerQuery,
                }
                params2 = _this.$qs.stringify(params2,{ indices: false });
                _this.axios({
                    method:'post',
                    url:window.API_HOST+'/chain/updateBlock',
                    data:params2,
                }).then((res)=>{
                  var data = res.data.blockHeight;
        						if(data != null){
        							block = data.id;
                      var b = {'blockHeight':data,'classA':'new','topA':'topA'};
                      _this.dataA.splice(0,0,b);
        						};
                  })
              },15000);
      	  	}else{
              $(".but_right").hide();
              $(".but_left").hide();
            }
      });
    },
    //获取当前时间
  },
  destroyed:function(){
    var _this = this;
    window.clearInterval(_this.setInterval_ID)
  }
}
</script>
<style lang="scss" scoped>
  @import '../../assets/css/block.css';

.list-item {
// display: inline-block;
margin-right: 10px;
}
.list-enter-active, .list-leave-active {
transition: all 1s;
}
.list-enter, .list-leave-to
/* .list-leave-active for below version 2.1.8 */ {
opacity: 0;
transform: translateY(120px);
}
  // #lll li.new{
  // 	width: 0;
  // }
  // #lll li.new>div{
  //   top: 100%;
  // }
  .title-value{
    background: #FFF;
    position: relative;
    overflow: hidden;
    .chain-title-a{
      text-align: center;
      padding:20px 0;
    }
  }
</style>
